import React, { ReactNode } from 'react';

import { FieldRow, Notification } from '@xsolla/ui-core';

import { AlertExclamationCircleIcon } from '../icons';
import { FieldBlockDescription, FieldBlockTitle, FieldBlockWrapper, InputWrapper } from './style';

type Props = {
  title?: ReactNode | string;
  description?: string;
  notification?: ReactNode;
  notificationBelow?: ReactNode;
  children?: ReactNode;
  contentMargin?: string;
  dataTestId?: string;
};

const FieldBlock = ({
  title,
  description,
  notification,
  children,
  contentMargin,
  notificationBelow,
  dataTestId
}: Props): JSX.Element => {
  return (
    <FieldRow justify="center" stretched>
      <FieldBlockWrapper>
        {title && <FieldBlockTitle>{title}</FieldBlockTitle>}
        {description && <FieldBlockDescription>{description}</FieldBlockDescription>}
        {notification && (
          <Notification caption="" icon={AlertExclamationCircleIcon} palette="brand">
            {notification}
          </Notification>
        )}
        <InputWrapper
          data-test-id={dataTestId || 'field-block-input-wrapper'}
          isTopMargin={!!(title || description || notification)}
          contentMargin={contentMargin}>
          {children}
        </InputWrapper>
        {notificationBelow && (
          <div data-test-id="notification-below">
            <Notification caption="" icon={AlertExclamationCircleIcon} palette="brand">
              {notificationBelow}
            </Notification>
          </div>
        )}
      </FieldBlockWrapper>
    </FieldRow>
  );
};

export default FieldBlock;
